import React from 'react';
import { Helmet } from 'react-helmet';
import { Loader } from 'semantic-ui-react';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import DatePagination from 'components/DatePagination';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
// @ts-ignore
import LoadingGate from 'components/LoadingGate';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER,
    PAYROLL
} from 'components/RoleGate/constants';
// @ts-ignore
import Online from 'components/Online';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';

// Child Components
// @ts-ignore
import TimesheetEntriesRequest from './components/TimesheetEntriesRequest';
// @ts-ignore
import TimesheetEntriesTable from './components/TimesheetEntriesTable';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const TimesheetEntries = (): React.ReactElement => (
    <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER, PAYROLL]}>
        <ErrorBoundary
            namespace="TimesheetEntries"
            FallbackComponent={<ErrorBoundaryAlert />}
        >
            <Helmet>
                <title>
                    {'Timesheet Entries - '}
                    {REACT_APP_PROJECT_NAME}
                </title>
            </Helmet>
            <Online>
                <TimesheetEntriesRequest />
            </Online>
            <PageTitleAndFilters
                title="Entries"
                CustomSearch={<DatePagination />}
                datePicker
                currentEntity
                currentSeason
                group
                groupMultiple
                workType
                workTypeMultiple
                entity
                entityMultiple
                person
                personMultiple
            />
            <PageWrapper top={0} bottom={50}>
                <LoadingGate
                    namespace="TIMESHEET_ENTRIES_LOAD"
                    LoadingComponent={<Loader active inline="centered" />}
                >
                    <ErrorGate namespace="TIMESHEET_ENTRIES_LOAD">
                        <TimesheetEntriesTable />
                    </ErrorGate>
                </LoadingGate>
            </PageWrapper>
        </ErrorBoundary>
    </RoleGate>
);

export default TimesheetEntries;
